import React, {useState, useEffect} from 'react';
import './App.css';
import HaikyuGenerator from "./HaikyuGenerator";

function App() {
  return (
    <div>
        <HaikyuGenerator />
    </div>
  );
}

export default App;
